import { InputAdornment, styled, Toolbar } from '@mui/material'
import {
    DataGrid,
    DataGridProps,
    QuickFilter,
    QuickFilterClear,
    QuickFilterControl,
    QuickFilterProps
} from '@mui/x-data-grid'
import { ComponentType, JSX, ReactNode } from 'react'
import TextField from '@mui/material/TextField'
import { Cancel, Search } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

declare module '@mui/x-data-grid' {
    interface ToolbarPropsOverrides {
        actions?: ReactNode
    }
}

export const StyledDataGrid: ComponentType<DataGridProps> = styled(DataGrid)(() => ({
    '& .MuiDataGrid-columnHeader': {
        marginTop: '10px'
    },
    '& .MuiDataGrid-cell': {
        color: 'black'
    },
    '& .MuiDataGrid-toolbarQuickFilter': {
        margin: '10px'
    },
    '& .MuiDataGrid-iconSeparator': {
        color: '#000000'
    },
    '& .daycare-active-false': {
        backgroundColor: '#cacaca'
    },
    '& .daycare-active-true': {
        backgroundColor: '#FFFFFF'
    }
}))

const StyledQuickFilter: ComponentType<QuickFilterProps> = styled(QuickFilter)({
    backgroundColor: '#fffdf9',
    borderTop: 'none'
})

export function QuickSearchToolbar({ actions }: { actions?: ReactNode }): JSX.Element {
    const { t } = useTranslation()

    return (
        <Toolbar sx={{ padding: '0 !important', borderBottom: 'none', gap: 2, flexWrap: 'wrap' }}>
            <StyledQuickFilter expanded>
                <QuickFilterControl
                    render={({ ref, ...other }) => (
                        <TextField
                            {...other}
                            sx={{
                                width: 260,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        border: '1px solid #fba530'
                                    },
                                    '&:hover fieldset': {
                                        border: '1px solid #fdd49a'
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: '1px solid #fdd49a'
                                    },
                                    backgroundColor: '#fffdf9'
                                }
                            }}
                            inputRef={ref}
                            aria-label={t('search')}
                            placeholder={t('search')}
                            size='small'
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <Search fontSize='small' />
                                        </InputAdornment>
                                    ),
                                    endAdornment: other.value ? (
                                        <InputAdornment position='end'>
                                            <QuickFilterClear
                                                edge='end'
                                                size='small'
                                                aria-label='Clear search'
                                                material={{ sx: { marginRight: -0.75 } }}
                                            >
                                                <Cancel fontSize='small' />
                                            </QuickFilterClear>
                                        </InputAdornment>
                                    ) : null,
                                    ...other.slotProps?.input
                                },
                                ...other.slotProps
                            }}
                        />
                    )}
                />
            </StyledQuickFilter>
            {actions}
        </Toolbar>
    )
}
